<template>
    <button
        type="button"
        class="fixed z-50 top-20 right-0 h-14 w-14 bg-white border rounded-bl-lg md:rounded-tl-lg"
        @click="showModal = true"
    >
        <div class="flex h-full flex-col justify-center items-center">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6.00001C2 4.89544 2.89543 4.00002 3.99999 4.00002H18C19.1045 4.00002 20 4.89544 20 6.00001V17.9999C20 19.1045 19.1045 19.9999 18 19.9999H3.99999C2.89543 19.9999 2 19.1045 2 17.9999V6.00001Z" fill="white"/>
                <path d="M6.99999 6.00001V2.00003M15 6.00001V2.00003M5.99999 9.99999H16M3.99999 19.9999H18C19.1045 19.9999 20 19.1045 20 17.9999V6.00001C20 4.89544 19.1045 4.00002 18 4.00002H3.99999C2.89543 4.00002 2 4.89544 2 6.00001V17.9999C2 19.1045 2.89543 19.9999 3.99999 19.9999Z" stroke="#374151" stroke-width="2.39999" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </button>

    <CalendarModal
        :show="showModal"
        @close="showModal = false"
        :size="`max-w-6xl`"
    >
        <Calendar />
        <div class="w-full flex justify-end pb-4 pr-2">
            <button @click="showModal = false" type="button" class="bg-success py-1 px-2 rounded-lg text-gray-100 mr-4">Close</button>
        </div>
    </CalendarModal>
</template>

<script setup>
import { ref } from 'vue'
import CalendarModal from '@/ComponentsDeprecated/Modal/CalendarModal'
import Calendar from "@/ComponentsDeprecated/Calendar/Calendar";

const showModal = ref(false)


</script>
